import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';
@Pipe({
  name: 'multiChoiceList'
})
export class MultiChoiceListPipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
    if (!items) return [];
    if (!searchText) return items;
    searchText = searchText.toLowerCase();
    return items.filter(item => {
      return item.value.toLowerCase().includes(searchText);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/rFF/pipes/multi-choice-list.pipe.ts